var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-sticky',{attrs:{"offset-top":0}},[_c('div',{staticClass:"count-down"},[_c('span',{staticClass:"count-down-text"},[_vm._v("距离结束剩余")]),_c('van-count-down',{attrs:{"time":_vm.time,"format":"DD 天 HH 时 mm 分 ss 秒"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }